<template>
    <div>
        <div class="m-4">
            <FilingClassificationPlanTree :mode="mode"
                                          :reset="treeResetKey"
                                          :structureId="structureId"
                                          :isForAddEditDeleteControl="true"/>
        </div>
    </div>
</template>
<script>
    import axios from "axios";
    import constants from "@/assets/js/constants";
    import FilingClassificationPlanTree from '../components/FilingClassificationPlanTree.vue';
    import * as utils from '@/assets/js/common.js'

    export default {
        name: 'ManageFilingClassificationPlan',
        components: { FilingClassificationPlanTree },
        props: {
            structureId: Number,
            mode: { type: Number, default: 3 }, // 1 => FilingPlanMode, 2 => ClassificationPlanMode, 3 => BothPlanModes
        },
        data() {
            return {
                treeResetKey: 1
            }
        },
        watch: {},
        mounted() {
        },
        methods: {}
    };
</script>
<style scoped>
</style>
